import FAQAsk from './FAQAsk.vue'
import FAQAskModal from './FAQAskModal.vue'

export { FAQAsk, FAQAskModal }
export default FAQAsk
